export default [
  { route: '/dashboard', icon: 'dashboard-1', name: 'Dashboard' },
  { route: '/estoque', icon: 'inventory', name: 'Estoque' },
  { route: '/compras', icon: 'purchase', name: 'Compras' },
  { route: '/vendas', icon: 'selling', name: 'Vendas' },
  { route: '/produtos', icon: 'products', name: 'Produtos' },
  { route: '/eventos', icon: 'events', name: 'Eventos' },
];
